import _ from 'lodash';

const objectIdRegExp = /\b[0-9a-f]{24}\b/g;
const objectIdWithMetadataRegExp = /\b[0-9a-f]{24},.+\b/g;
const emailRegExp =
  /\b[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+(\+outlier)?)+\b/g;
const slackIdRegExp = /\b\w{11}\b/g;
const sfnExecutionRegExp =
  /^arn:aws:states:[a-z0-9-]+:[0-9]{12}:execution:[a-zA-Z0-9-_]*:[a-zA-Z0-9-_]*$/;
const cdsUrlRegExp = /\b(?:scale-cds:\/\/)?([0-9a-f]{24}\/[A-Za-z0-9_-]{15})(?:#.+)?\b/;
const taskPipelineEntityRegExp = /^[nermh]-[a-zA-Z0-9]{21}/;
const discourseIdRegExp = /^DIS-[a-zA-Z0-9]{16}/;
const v2ApiResponseUrlRegExp = /https:\/\/api\.scale\.com\/v2\/.*\/response_url\//;

export function parseObjectIds(inputText: string): string[] {
  return parseGroups(inputText, objectIdRegExp);
}

export function parseObjectIdsWithMetadata(inputText: string): [string, string][] {
  const groups = inputText.match(objectIdWithMetadataRegExp) || [];
  const res: [string, string][] = [];
  for (const group of groups) {
    const ind = group.indexOf(',');
    res.push([group.slice(0, ind), group.slice(ind + 1)]);
  }
  return res;
}

export function parseEmails(inputText: string): string[] {
  // Based on definition of a valid email address from w3resource.com
  return parseGroups(inputText, emailRegExp);
}

export function parseSlackIds(inputText: string): string[] {
  return parseGroups(inputText, slackIdRegExp);
}

function parseCdsUrl(inputText: string): string[] {
  return parseGroups(inputText, cdsUrlRegExp);
}

export function matchesLookupId(inputText: string): string[] | null {
  return (
    inputText.match(v2ApiResponseUrlRegExp) ??
    inputText.match(objectIdRegExp) ??
    inputText.match(sfnExecutionRegExp) ??
    inputText.match(cdsUrlRegExp) ??
    inputText.match(taskPipelineEntityRegExp) ??
    inputText.match(discourseIdRegExp)
  );
}

export function parseLookupId(inputText: string): string | undefined {
  // must parse v2ApiResponseUrl and cdsUrl first before objectId
  if (inputText.match(v2ApiResponseUrlRegExp)) {
    return inputText.trim();
  }
  if (inputText.match(cdsUrlRegExp)) {
    const url = `scale-cds://${parseCdsUrl(inputText)[1]}`;
    return url;
  }
  if (inputText.match(taskPipelineEntityRegExp)) return inputText;
  if (inputText.match(objectIdRegExp)) return parseObjectIds(inputText)[0];
  if (inputText.match(sfnExecutionRegExp)) return inputText;
  if (inputText.match(discourseIdRegExp)) return inputText;
}

function parseGroups(inputText: string, groupRegExp: RegExp): string[] {
  const groups = inputText.match(groupRegExp) || [];
  return _.uniq(groups);
}
